<!-- @format -->

<template>
    <div class="gst-room-amenities">
        <DynamicHeightInlineList
            :items="amenitiesVisible"
            :number-of-rows="numberOfRows"
            class="gst-room-amenities__list">
            <template #actions="{ showAction }">
                <button
                    v-if="showAction"
                    class="gst-room-amenities__all-amenities-button d-flex align-center"
                    @click="openRoomAmenitiesModal">
                    {{ $t('_common:entities.roomAmenities.allAmenitiesButton') }}
                    <BaseIcon symbol-id="icons--chevron_right" />
                </button>
            </template>
        </DynamicHeightInlineList>
    </div>
</template>

<script>
import DynamicHeightInlineList from '../../lists/DynamicHeightInlineList.vue';

export default {
    name: 'RoomAmenities',
    components: {
        DynamicHeightInlineList,
    },
    props: {
        amenities: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        amenitiesVisible() {
            return this.amenities
                .filter((item) => item.quantity !== 0)
                .map((item) => this.$options.filters.roomAmenity(item));
        },
        numberOfRows() {
            return this.$vuetify.breakpoint.mdAndUp ? 3 : 2;
        },
    },
    methods: {
        openRoomAmenitiesModal() {
            const modalConfigDesktop = {
                'no-click-animation': true,
                scrollable: true,
                fullscreen: false,
                'hide-overlay': false,
                'max-width': 628,
                'content-class': 'v-dialog__height-45 gst-v-dialog',
            };

            const modalConfigMobile = {
                'content-class': 'v-dialog__height-60 gst-v-dialog',
                scrollable: true,
                fullscreen: false,
                'hide-overlay': false,
                transition: 'dialog-bottom-transition',
            };

            const modalComponent = import('../../modals/RoomAmenitiesModal.vue');
            const modalComponentProps = {
                amenities: this.amenitiesVisible,
            };

            if (this.$vuetify.breakpoint.mdAndUp) {
                this.$modal.show(modalComponent, modalComponentProps, modalConfigDesktop);
            } else {
                this.$modal.showBottom(modalComponent, modalComponentProps, modalConfigMobile);
            }
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-room-amenities {
    .gst-room-amenities__list {
        line-height: line-height('xxxxl');
        font-size: font-size('xxxs');

        .gst-list__item-pill {
            padding: theme-spacing(0, 1);
            margin: theme-spacing(1, 1, 0, 0);
            background-color: theme-color('background-success');
            color: theme-color('success');
            border-radius: 4px;
        }
    }

    .gst-room-amenities__all-amenities-button {
        padding-right: theme-spacing(1);
        padding-left: theme-spacing(1);
        margin-top: theme-spacing(2);
        color: theme-color('primary');
        font-size: font-size('xxs');
        font-weight: font-weight('large');

        .gst-base-icon {
            height: 16px;
            width: 16px;

            path {
                fill: theme-color('primary') !important;
            }
        }
    }
}
</style>
